import { currentDirection, directionMatches } from "../command";
import { BUTTON } from "../input";
import { BACK_TURNED_FRAMES } from "../turn";
import { sub, toPixels } from "../../shared/fixed";
import type { ActionHandler } from "./registry";

/** Рывок вперёд: скорость в пикселях за кадр, гаснет трением. params: { speed } */
export const dash: ActionHandler = ({ self }, { speed = 6 }) => {
  self.vx = sub(speed) * self.facing;
};

/** Прыжок из приёма — сальто, удар в прыжке. params: { up, forward } */
export const leap: ActionHandler = ({ self }, { up = 8, forward = 3 }) => {
  self.vy = -sub(up);
  self.vx = sub(forward) * self.facing;
};

/** Телепорт за спину сопернику. params: { distance } — пикселей за его спиной. */
export const teleport: ActionHandler = ({ self, other, rules, frame, side, emit }, { distance = 40 }) => {
  const from = toPixels(self.x);
  const behind = other.x - self.x >= 0 ? 1 : -1;
  const half = sub(rules.heroes[side].width / 2);
  const target = other.x + behind * sub(distance);
  self.x = Math.min(Math.max(target, sub(rules.arena.left) + half), sub(rules.arena.right) - half);
  self.facing = other.x - self.x >= 0 ? 1 : -1;
  // контрприём (Джон: «чтобы враг мог это как-то контрить»): соперник видел замах и держит назад + блок —
  // встречает лицом и в блоке; иначе не сразу замечает и стоит спиной (удар в спину не блокируется)
  const ready = (other.lastBits & BUTTON.block) !== 0 && directionMatches(currentDirection(other), "B");
  if (ready && other.y >= 0) {
    other.facing = self.x > other.x ? 1 : -1;
    other.turnLock = 0;
  } else other.turnLock = BACK_TURNED_FRAMES;
  emit({ kind: "action", frame, who: side, x: toPixels(self.x), y: -74, strength: 1, fx: "teleport/in", fromX: from });
};
